export default "__VITE_ASSET__CfuV8og6__"